/**
 * What a graph widget remembers on this device (I-7): zoom and pan, node positions, the auto-centre
 * toggle. View state, never workspace data — kept in localStorage per widget, like the last-opened
 * dashboard. Both renderers store positions as node centres in model coordinates, so switching
 * between Cytoscape and React Flow keeps an arrangement.
 */
import type { Point } from "./model";

export interface GraphViewState {
  zoom?: number;
  pan?: Point;
  positions?: Record<string, Point>;
  /** pan the drawing back into the middle after every redraw (KSS ADR 0010); on by default */
  autoCentre?: boolean;
  /** the layout the positions came from; a different layout starts fresh */
  layout?: string;
}

const PREFIX = "drang.graph.";

export function loadViewState(key: string | undefined): GraphViewState {
  if (!key) return {};
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as GraphViewState) : {};
  } catch {
    return {};
  }
}

export function saveViewState(key: string | undefined, patch: GraphViewState): void {
  if (!key) return;
  try {
    const cur = loadViewState(key);
    localStorage.setItem(PREFIX + key, JSON.stringify({ ...cur, ...patch }));
  } catch {
    /* private mode or quota: the view simply is not remembered */
  }
}
